import React from "react";
import { useSelector } from "react-redux";
import { selectDarkMode } from "../../../../app/store/slices/uiSlice";

export default function FormTextarea({
  label,
  name,
  value,
  onChange,
  required = false,
  placeholder = "",
  disabled = false,
  rows = 4,
  error = "",
  className = "",
  hideLabel = true,
  ...props
}) {
  const darkMode = useSelector(selectDarkMode);

  const baseClass = "w-full border rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 transition-colors resize-none";
  const borderClass = error
    ? "border-red-500 focus:ring-red-500"
    : darkMode
      ? "border-gray-600 focus:ring-blue-500 bg-gray-700 text-white placeholder-gray-400"
      : "border-gray-300 focus:ring-blue-500 bg-white";

  const disabledClass = disabled
    ? darkMode ? "bg-gray-800 cursor-not-allowed text-gray-400" : "bg-gray-100 cursor-not-allowed"
    : "";

  return (
    <div className="form-group">
      {!hideLabel && label && (
        <label htmlFor={name} className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-200' : 'text-[#232526]'}`}>
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <textarea
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        placeholder={placeholder}
        disabled={disabled}
        rows={rows}
        className={`${baseClass} ${borderClass} ${disabledClass} ${className}`}
        {...props}
      />
      {error && <p className="text-sm text-red-500 mt-1">{error}</p>}
    </div>
  );
}
